import React, { useEffect, useState } from "react";
import { Typography, Grid, Paper, Box } from "@mui/material";
import { handleAxiosError } from "../../config/action-config";
import { useDispatch, useSelector } from "react-redux";
import { getEmployeeResignationDetailById } from "../../api/resignation";
import { CircularProgress, makeStyles } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  label: {
    color: "grey",
    fontWeight: "bold",
  },
}));
const EmployeeResignationDetails = ({ setCurrentStatus }) => {
  const classes = useStyles();
  const [resignationData, setResignationData] = useState(null);
  const [error, setError] = useState(null);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    loadResignationDetails();
  }, [user.resignation_initiated]);

  const loadResignationDetails = async () => {
    try {
      const { data } = await getEmployeeResignationDetailById(user.token);
      setResignationData(data.data.emp_resignation[0]);
      setCurrentStatus(data.data.emp_resignation[0].current_status);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  };

  if (error) {
    return (
      <Typography variant="body1" color="error">
        {error}
      </Typography>
    );
  }

  if (!resignationData) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height={200} // Adjust height according to your design
      >
        <CircularProgress />
      </Box>
    );
  }

  const {
    id,
    emp_id,
    first_name,
    last_name,
    email,
    contact,
    designation,
    department,
    joining_date,
    employment_status,
    job_location,
    created_by,
    ...filteredResignationData
  } = resignationData;
  const isDateKey = (key) => {
    return (
      key === "previous_job_from" || key === "previous_job_to" || key === "dob"
    );
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    });
  };
  return (
    <Paper sx={{ p: "1rem" }}>
      <Grid container spacing={2}>
        {Object.entries(filteredResignationData).map(([key, value]) => (
          <Grid item xs={12} md={4} key={key}>
            <Box sx={{ padding: 1 }}>
              <Typography className={classes.label}>
                {convertSnakeToPascalCase(key)}
              </Typography>

              <Typography variant="body1">
                {isDateKey(key) ? formatDate(value) : value || "N/A"}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};
const convertSnakeToPascalCase = (str) => {
  const customTitles = {
    dob: "Date Of Birth",
    uan_number: "UAN Number",
    // Add more custom titles as needed
  };

  if (customTitles[str]) {
    return customTitles[str];
  }

  return str
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};
export default EmployeeResignationDetails;
